





















import Vue from 'vue'

export default Vue.extend({
  name: 'AppNotificationsItem',
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  mounted () {
    setTimeout(() => {
      this.$store.commit('global/deleteNotification', this.notification.id)
    }, 10000)
  }
})
